import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { KeyboardEventHandler, useLayoutEffect } from 'react';

interface KeydownPluginProps {
  onKeyDown?: KeyboardEventHandler;
}

// FIXME: remove any

export function KeydownPlugin({ onKeyDown }: KeydownPluginProps) {
  const [editor] = useLexicalComposerContext();

  useLayoutEffect(() => {
    if (!onKeyDown) return;

    return editor.registerRootListener(
      (
        rootElement: null | HTMLElement,
        prevRootElement: null | HTMLElement,
      ) => {
        if (prevRootElement !== null) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          prevRootElement.removeEventListener('keydown', onKeyDown as any, {
            capture: true,
          });
        }
        if (rootElement !== null) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          rootElement.addEventListener('keydown', onKeyDown as any, {
            capture: true,
          });
        }
      },
    );
  }, [editor, onKeyDown]);

  return null;
}
